import React from 'react';
import { StyledFileIcon, StyledFileName, StyledInsertDriveFile } from './attachmentPopover.style';

interface FileIconProps {
  fileName: string;
}

const FileIcon = ({ fileName }: FileIconProps) => {
  const getType = (fileName: string) => {
    const lastDotIndex = fileName.lastIndexOf('.');
    const type = fileName.slice(lastDotIndex + 1);
    return type;
  };

  return (
    <StyledFileIcon>
      <StyledFileName variant="body2">{getType(fileName)}</StyledFileName>
      <StyledInsertDriveFile />
    </StyledFileIcon>
  );
};

export default FileIcon;
